import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Clock } from 'lucide-react';
import { OVERTIME_RANGES } from '@/utils/overtimeColorCoding';

interface OvertimeColorLegendProps {
  className?: string;
}

export function OvertimeColorLegend({ className }: OvertimeColorLegendProps) {
  // Use centralized ranges, excluding the normal (≤40 hours) range for legend display
  const legendItems = OVERTIME_RANGES.filter(range => range.maxHours > 40);

  return (
    <div className={`flex flex-wrap items-center gap-3 text-sm ${className}`}>
      <span className="text-muted-foreground font-medium">Color Legend:</span>
      {legendItems.map((range) => {
        const { colorScheme, label, description } = range;
        return (
          <div key={label} className="flex items-center gap-2">
            <Badge 
              variant={colorScheme.badgeVariant}
              className={`px-2 py-1 text-xs ${colorScheme.backgroundColor} ${colorScheme.textColor} ${colorScheme.borderColor} border`}
            >
              <Clock className="h-3 w-3 mr-1" />
              {label}
            </Badge>
            <span className="text-muted-foreground text-xs hidden sm:inline">
              ({description})
            </span>
          </div>
        );
      })}
      <div className="text-xs text-muted-foreground ml-2">
        <span className="font-medium">Note:</span> Shade intensity increases within each bracket
      </div>
    </div>
  );
}
